import { Component, Emitter } from '@wonderlandengine/api';

/**
 * TriggerTarget component that emits an event when triggered.
 * This component is used as an intermediate for triggering actions
 */
export class TriggerTarget extends Component {
    static TypeName = 'triggerTarget';

    onExecute: Emitter = new Emitter();

    execute() {
        this.onExecute.notify();
    }
}
